// extracted by mini-css-extract-plugin
export default {"roles":"JoinPage_roles__v-QZT","rolesWrapper":"JoinPage_rolesWrapper__3TOtz","rolesTitle":"JoinPage_rolesTitle__r9B5D"};